module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_111_4.3bac7566.pdf";